import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import layoutTask from "@/components/layout/LayoutTask.vue";
import NotFound from "@/components/layout/NotFound.vue";
import { useUserStore } from "@/store";
// import { message } from "ant-design-vue";
// 这个地方 需要手动将pinia实例注入到useUserStore，否则获取不到pinia实例
const routes: Array<RouteRecordRaw> = [
  { path: "/", redirect: { path: "/task" } },
  { path: "/login", name: "Login", component: () => import("@/views/login/LoginView.vue"), meta: { nologin: true } },
  // 扫描题卡独立路由
  {
    name: "TemplateScan",
    path: "/template-scan/:taskId/:subjectId",
    component: () => import("@/views/task/templateMaking/TemplateScan.vue"),
    meta: {
      title: "扫描题卡",
      allowFull: true,
    },
  },
  // 模板编辑独立路由
  {
    name: "TemplateEdit",
    path: "/template-edit/:taskId/:subjectId",
    component: () => import("@/views/task/templateMaking/TemplateEdit.vue"),
    meta: {
      title: "模板编辑",
      allowFull: true,
    },
  },
  // 异常处理独立路由
  {
    name: "SheetAbnormal",
    path: "/sheet-abnormal/:taskId/:taskName",
    component: () => import("@/views/task/paperScan/SheetAbnormal.vue"),
    meta: {
      title: "定位及考号异常处理",
      allowFull: true,
    },
  },
  // 考试管理
  {
    name: "Task",
    path: "/task",
    meta: { parent: "Task", title: "考试管理", link: "/task" },
    component: layoutTask,
    redirect: "/task", //解决面包屑跳转考试管理没有渲染内容
    children: [
      {
        name: "TaskList",
        path: "",
        component: () => import("@/views/task/taskList/TaskList.vue"),
        meta: { parent: "Task", title: "考试管理", link: "/task", crumb: false },
      },
      {
        name: "TaskCreate",
        path: "create",
        component: () => import("@/views/task/taskCreate/TaskCreate.vue"),
        meta: { parent: "Task", title: "创建任务", link: "/task/create", crumb: true },
      },
      {
        name: "TaskEdit",
        path: "edit/:taskId",
        component: () => import("@/views/task/taskCreate/TaskCreate.vue"),
        meta: { parent: "Task", title: "编辑任务", link: "/task/edit", crumb: true },
      },
      {
        name: "TikaSetting",
        path: "tikaSetting/:taskId&:taskName",
        component: () => import("@/views/task/tikaSetting/TikaSetting.vue"),
        meta: {
          parent: "Task",
          title: "题卡设置",
          link: "/task/tikaSetting",
          crumb: true,
          help: {
            link: "https://yj.21cnjy.com/help/video2/48",
            title: "如何进行题卡设置",
          },
          progress: 1, //是否有任务进度模块
        },
      },
      {
        name: "MarkSetting",
        path: "markSetting/:taskId&:taskName",
        component: () => import("@/views/task/markSetting/MarkSetting.vue"),
        meta: {
          parent: "Task",
          title: "阅卷设置",
          link: "/task/markSetting",
          crumb: true,
          help: {
            link: "https://yj.21cnjy.com/help/video2/50",
            title: "如何进行阅卷设置",
          },
          progress: 2, //是否有任务进度模块
        },
      },
      {
        name: "PaperScanContainer",
        path: "paperScan/:taskId&:taskName",
        component: () => import("@/views/task/paperScan/scanContainer.vue"),
        redirect: { name: "SheetScan" },
        meta: { parent: "Task", link: "/task/paperScan", crumb: true, },
        children: [
          {
            name: "PaperScan",
            path: "paperScan",
            component: () => import("@/views/task/paperScan/PaperScan.vue"),
            meta: {
              parent: "Task",
              title: "扫描监控",
              // link: "/task/paperScan",
              crumb: true,
              
              // help: {
              //   link: "https://yj.21cnjy.com/help/video2/52",
              //   title: "如何进行题卡扫描",
              // },
              progress: 4, //是否有任务进度模块
            },
          },
          {
            name: "SheetScan",
            path: "",
            component: () => import("@/views/task/paperScan/SheetScan.vue"),
            meta: {
              parent: "Task",
              title: "答卷扫描",
              help: {
                link: "https://yj.21cnjy.com/help/video2/54",
                title: "如何进行答卷扫描",
              },
              crumb: true,
              
              progress: 4,
            },
          },
        ]
      },
      {
        name: "TemplateMaking",
        path: "templateMaking/:taskId&:taskName",
        component: () => import("@/views/task/templateMaking/TemplateMaking.vue"),
        meta: {
          parent: "Task",
          title: "模板制作",
          link: "/task/templateMaking",
          crumb: true,
          help: {
            link: "https://yj.21cnjy.com/help/video2/52",
            title: "如何进行模板制作",
          },
          progress: 3, //是否有任务进度模块
        },
      },
      {
        name: "ProgressMonitoring",
        path: "progressMonitoring/:taskId&:taskName",
        component: () => import("@/views/task/progressMonitoring/ProgressMonitoring.vue"),
        meta: {
          parent: "Task",
          title: "进度监控",
          link: "/task/progressMonitoring",
          crumb: true,
          progress: 5, //是否有任务进度模块
        },
      },
      {
        name: "ExceptionHandling",
        path: "exceptionHandling/:taskId&:taskName",
        component: () => import("@/views/task/exceptionHandling/ExceptionHandling.vue"),
        meta: {
          parent: "Task",
          title: "异常处理",
          link: "/task/exceptionHandling",
          crumb: true,
          help: {
            link: "https://yj.21cnjy.com/help/video2/56",
            title: "如何进行异常处理",
          },
          progress: 6,  //是否有任务进度模块
        },
      },
      {
        name: "ScoreRelease",
        path: "scoreRelease/:taskId&:taskName",
        component: () => import("@/views/task/scoreRelease/ScoreRelease.vue"),
        meta: {
          parent: "Task",
          title: "成绩发布",
          link: "/task/scoreRelease",
          crumb: true,
          help: {
            link: "https://yj.21cnjy.com/help/video2/57",
            title: "如何进行成绩发布",
          },
          progress: 7,  //是否有任务进度模块
        },
      },
      {
        name: "ToolBox",
        path: "toolBox/:taskId",
        component: () => import("@/views/task/toolBox/ToolBox.vue"),
        meta: { parent: "Task", title: "工具箱", link: "/task/toolBox", crumb: true },
        children: [
          {
            name: "OrinalPaper",
            path: "orinalPaper",
            props: true,
            component: () => import("@/views/task/orinalPaper/OrinalPaper.vue"),
            meta: { parent: "Task", title: "下载原卷", link: "/task/toolBox/orinalPaper", crumb: true },
          },
          {
            name: "ScoreCorrection",
            path: "scoreCorrection",
            props: true,
            component: () => import("@/views/task/scoreCorrection/ScoreCorrection.vue"),
            meta: { parent: "Task", title: "评分修正", link: "/task/scoreCorrection", crumb: true },
          },
          {
            name: "ExceptionCheck",
            path: "exceptionCheck",
            props: true,
            component: () => import("@/views/task/scoreCorrection/ScoreCorrection.vue"),
            meta: { parent: "Task", title: "异常学生校验", link: "/task/exceptionCheck", crumb: true },
          },
          {
            name: "ReviewManage",
            path: "reviewManage",
            props: true,
            component: () => import("@/views/task/reviewManage/ReviewManage.vue"),
            meta: { parent: "Task", title: "阅卷管理", link: "/task/reviewManage", crumb: true },
          },
          {
            name: "AdditionalRecording",
            path: "additionalRecording",
            props: true,
            component: () => import("@/views/task/additionalRecording/AdditionalRecording.vue"),
            meta: { parent: "Task", title: "成绩补录", link: "/task/additionalRecording", crumb: true },
          },
          {
            name: "ReviewManage",
            path: "reviewManage",
            props: true,
            component: () => import("@/views/task/reviewManage/ReviewManage.vue"),
            meta: { parent: "ToolBox", title: "阅卷管理", link: "/task/reviewManage", crumb: true },
          },
          {
            name: "AdditionalRecording",
            path: "additionalRecording",
            props: true,
            component: () => import("@/views/task/additionalRecording/AdditionalRecording.vue"),
            meta: { parent: "ToolBox", title: "成绩补录", link: "/task/additionalRecording", crumb: true },
          },
        ],
      },
      {
        name: "SpotCheck",
        path: "spotCheck",
        component: () => import("@/views/task/spotCheck/SpotCheck.vue"),
        meta: { parent: "Task", title: "抽查", link: "/task/spotCheck", crumb: true },
      },
    ],
  },
  // 网上阅卷
  {
    name: "OnlineCheck",
    path: "/onlineCheck",
    component: layoutTask,
    redirect: { path: "/onlineCheck/list" },
    meta: { parent: "OnlineCheck", title: "网上阅卷", link: "/reviewList" },
    children: [
      {
        name: "ReviewList",
        path: "list",
        component: () => import("@/views/onlineCheck/reviewList/ReviewList.vue"),
        meta: { parent: "OnlineCheck", title: "任务列表", link: "/reviewList", crumb: true },
      },
      {
        name: "Problem",
        path: "problem",
        component: () => import("@/views/onlineCheck/problemPaper/ProblemPaper.vue"),
        meta: { parent: "OnlineCheck", title: "问题卷处理", link: "/problem", crumb: true },
      },
      {
        name: "Evaluations",
        path: "evaluations",
        component: () => import("@/views/onlineCheck/evaluationsPaper/EvaluationsPaper.vue"),
        meta: { parent: "OnlineCheck", title: "三评卷处理", link: "/evaluations", crumb: true },
      },
      {
        name: "ReviewProgress",
        path: "progress",
        component: () => import("@/views/onlineCheck/reviewProgress/ReviewProgress.vue"),
        meta: { parent: "OnlineCheck", title: "评阅进度", link: "/progress", crumb: true },
      },
      {
        name: "Arbitration",
        path: "arbitration",
        component: () => import("@/views/onlineCheck/arbitrationPaper/ArbitrationPaper.vue"),
        meta: { parent: "OnlineCheck", title: "仲裁卷处理", link: "/arbitration", crumb: true },
      },
      {
        name: "Review",
        path: "review",
        component: () => import("@/views/onlineCheck/reviewPage/ReviewPage.vue"),
        meta: { parent: "OnlineCheck", title: "评阅页面", link: "/review", crumb: true, allowFull: true },
      },
    ],
  },
  // 系统设置
  {
    name: "System",
    path: "/system",
    redirect: { path: "/system/information" },
    component: layoutTask,
    children: [
      {
        name: "Information",
        path: "information",
        component: () => import("@/views/system/basicInformation/BasicInformation.vue"),
        meta: { parent: "System", title: "师生信息", link: "/information", crumb: true },
      },
      {
        name: "Alliance",
        path: "alliance",
        component: () => import("@/views/system/allianceSetting/AllianceSetting.vue"),
        meta: { parent: "System", title: "联盟设置", link: "/alliance", crumb: true },
      },
      {
        name: "Authority",
        path: "authority",
        component: () => import("@/views/system/roleAuthority/RoleAuthority.vue"),
        meta: { parent: "System", title: "权限设置", link: "/authority", crumb: true },
      },
      {
        name: "Operation",
        path: "operation",
        component: () => import("@/views/system/operationLog/OperationLog.vue"),
        meta: { parent: "System", title: "操作记录", link: "/operation", crumb: true },
      },
    ],
    meta: { parent: "System", title: "系统设置", link: "/system" },
  },

  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to) => {
  // 如果没有登录信息且页面需要登录
  const UserStore = useUserStore();
  // 登录页不参与已登录用户的权限重定向，否则从业务页切换到
  // /login?sessionid=xxx 时会被旧用户的权限直接拦回原页面。
  if (to.meta.nologin) {
    return true;
  }
  if (!UserStore.userInfo.authorization) {
    router.replace({ path: "/login" });
    return false;
  }
  /**
   *  1.当响应的用户角色(type)==0 && 角色权限(customRole)==null  只显示网上阅卷模块  此时用户的角色为普通老师
      2.当响应的用户角色(type)==0 && 角色权限(customRole)!=null  只显示网上阅卷+考试管理模块  此时用户的角色为普通老师，但管理员给与给老师自定义角色权限
      3.当响应的用户角色(type)==1  显示网上阅卷+考试管理+系统设置模块  此时用户的角色为学校管理员
   */
  let auth = 0;
  if (UserStore.userInfo.type == 1) {
    auth = 3;
  } else if (UserStore.userInfo.type == 0 && UserStore.userInfo.customRole == null) {
    auth = 1;
  } else {
    auth = 2;
  }
  if (auth === 2 && to.meta.parent == "System") {
    // message.error("您没有权限访问此页面");
    router.replace({ path: "/task" });
    return false;
  } else if (auth === 1 && to.meta.parent != "OnlineCheck") {
    // message.error("您没有权限访问此页面");
    router.replace({ name: "OnlineCheck" });
    return false;
  }
  // 路由发生变化修改页面title
  // if (to.meta.title) {
  //   document.title = "二一阅卷—" + to.meta.title;
  // }
});
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    router.go(0);
  }
});
export default router;
